import axios, { AxiosResponse } from 'axios'

export type IssuedMaterialFilter = {
  query?: string
  fromDate?: string
  toDate?: string
  repId?: number
  rayonId?: number
  brickId?: number
  productId?: number
  tierId?: number
  userId?: number
  labelId?: number
  clientId?: number
}

export type IssuedMaterialPage = IssuedMaterialFilter & {
  limit: number
  offset: number
}

export class IssuedMaterialService {
  public getAll(page: IssuedMaterialPage): Promise<AxiosResponse> {
    return axios.get('/api/v1/issued-materials', { params: page })
  }

  public export(filter: IssuedMaterialFilter): Promise<AxiosResponse> {
    return axios.get('/api/v1/issued-materials/export', {
      responseType: 'blob',
      params: filter,
    })
  }
}
